import { Component } from '@angular/core';

@Component({
  selector: 'app-academiclink',
  templateUrl: './academiclink.component.html',
  styleUrls: ['./academiclink.component.scss']
})
export class AcademiclinkComponent {

}
